import React, { useEffect, useState, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import { ReactComponent as PlusIcon } from '../Assets/svg/PlusIcon.svg';
import { ReactComponent as CameraIcon } from '../Assets/svg/CameraIcon.svg';
import http from '../api/axiosInstance'
import { PropertyContext } from '../context/property-context'
import { Box } from '@mui/system';
import { IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import Cookies from 'js-cookie'
import imageCompression from 'browser-image-compression';

function DropZone(props) {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [state, dispatch] = useContext(PropertyContext);

    const { enqueueSnackbar } = useSnackbar();

    const { getRootProps, getInputProps, fileRejections } = useDropzone({
        accept: {
            'image/*': []
        },
        onDrop: async acceptedFiles => {
            const tmp = [...props.imgUploadsCount]
            let isfull = false
            let isError = false
            if (props.imgUploadsCount.length < 10 && props.number == props.imgUploadsCount.length) {
                setFiles(acceptedFiles.map(file => Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })));


                console.log("acceptedFiles", acceptedFiles)
                console.log('props.imgUploadsCount.length', props.imgUploadsCount.length)
                let formData = new FormData();
                formData.append('Prefix', JSON.parse(Cookies.get('agency')).Id)


                setLoading(true)
                props.setUploadingPictures(true)
                let index = 0
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1920,
                    useWebWorker: true,
                };
                for (let item of acceptedFiles) {                       
                    console.log("index + props.imgUploadsCount.length", index + props.imgUploadsCount.length)
                    if (index + props.imgUploadsCount.length >= 9 || index >= 9 || props.imgUploadsCount.length >= 9) {
                        isfull = true
                    }
                    if (index + props.imgUploadsCount.length < 10) {
                        try {
                            const compressedFile = await imageCompression(item, options);
                            var fileOfBlob = new File([compressedFile], item.name);
                            console.log(
                                "compressedFile instanceof Blob",
                                compressedFile instanceof Blob
                            ); // true
                            console.log(
                                `compressedFile size ${compressedFile.size / 1024 / 1024} MB`
                            ); // smaller than maxSizeMB
                            console.log(`compressedFile size`, compressedFile); // smaller than maxSizeMB
                            formData.append("File", compressedFile);
                        } catch (error) {
                            console.log(error, "fff");
                        }
                        
                        try {
                            await http({
                                // url of the api endpoint (can be changed)
                                url: "temporary/picture/upload",
                                method: "POST",
                                data: formData
                            }).then((res) => {

                                console.log(res);
                                if (res.data.result) {
                                    dispatch({
                                        type: "ADD_PICTURES",
                                        payload: [props.number, res.data.result.Name]
                                    });
                                    console.log('Pictures', state.Pictures)
                                    tmp.pop()
                                    tmp.push(item)
                                    tmp.push({})
                                    if (isfull) {
                                        props.setImgUploadsCount(tmp.slice(0, -1))
                                    }
                                }
                                
                                props.setUploadingPictures(false)

                            });
                        } catch (e) {
                            console.error(e);
                            if (e.response) {
                                const variant = 'error'
                                enqueueSnackbar(e.response.data.message, { variant });
                            }
                            isError = true
                            
                            props.setUploadingPictures(false)

                        }
                        console.log("props.imgUploadsCount.length", props.imgUploadsCount.length, tmp)


                        // props.setImgUploadsCount(tmp)


                    }

                    index++
                }
                setLoading(false)
                // acceptedFiles.map(async (item, index) => {

                // })
                props.setImgUploadsCount(tmp)
            } else {
                props.setImgUploadsCount(tmp.slice(0, -1))
            }



        }
    });



    const thumbs =
        <div key={props.file && props.file.name}>

            {props.file && props.file.preview && props.file.preview != "" && <img
                src={props.file && props.file.preview}

                // Revoke data uri after image is loaded
                onLoad={() => { URL.revokeObjectURL(props.file && props.file.preview) }}
            />}

            {props.number == 1 && <Box className='majorImg'>عکس اصلی</Box>}

        </div>


    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));


    }, []);

    useEffect(() => {
        console.log("fileRejections", fileRejections)
        if (fileRejections.length) {
            const variant = 'error'
            fileRejections.map(item => {
                enqueueSnackbar(`فایل ${item.file.name} آپلود نشد.`, { variant });
            })
            setLoading(false)
        }

    }, [fileRejections]);

    useEffect(() => {
        console.log("files", files)
    }, [files]);

    const handleDeleteImg = () => {
        console.log("props.file.preview", props.pictures[props.number - 1])
        setLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/clean-image",
                method: "POST",
                data: {
                    "Prefix": JSON.parse(Cookies.get('agency')).Id,
                    "Picture": props.pictures[props.number - 1]
                }
            }).then((res) => {

                console.log(res);
                if (res.data.result) {
                    setLoading(false)

                    const tmpImgUploadsCount = [...props.imgUploadsCount]
                    props.setImgUploadsCount(tmpImgUploadsCount.filter((item, index) => index != props.number - 1))
                    dispatch({
                        type: "REMOVE_PICTURES",
                        payload: { name: props.pictures[props.number - 1] }
                    });
                    console.log('Pictures', state.Pictures)
                    if (props.setDeletedImagesHandle)
                        props.setDeletedImagesHandle(props.pictures[props.number - 1])
                }
                setLoading(false)

            });
        } catch (e) {
            console.error(e);
            setLoading(false)
        }
    }

    return (
        <section className="container-dropzone">
            <div>
                {props.file && props.file.preview && props.file.preview != "" && <IconButton sx={{ position: "absolute", zIndex: "2", width: "40px" }} onClick={handleDeleteImg}><img src='/assets/img/icons8-delete-48.png' /></IconButton>}

                <div {...getRootProps({ className: 'dropzone' })}>
                    {
                        loading ?
                            <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: '2', position: 'absolute', bgcolor: '#ffffffa3' }}>
                                <img src='/assets/img/ladng2.gif' width='30' />
                            </Box>
                            :
                            null
                    }
                    <input {...getInputProps()} />
                    <PlusIcon width='10' height="10" />
                    <CameraIcon />
                    <div className='dropzone-img'>
                        {thumbs}
                    </div>
                    <span className='dropzone-number'>
                        {props.number}
                    </span>
                </div>
            </div>
        </section>
    );
}

export default DropZone;